// Get Project Packages
export const GET_PROJECT_PACKAGES = "GET_PROJECT_PACKAGES"
export const GET_PROJECT_PACKAGES_SUCCESS = "GET_PROJECT_PACKAGES_SUCCESS"
export const GET_PROJECT_PACKAGES_FAIL = "GET_PROJECT_PACKAGES_FAIL"

// Get All Project Packages (for Installer)
export const GET_ALL_PROJECT_PACKAGES = "GET_ALL_PROJECT_PACKAGES"
export const GET_ALL_PROJECT_PACKAGES_SUCCESS = "GET_ALL_PROJECT_PACKAGES_SUCCESS"
export const GET_ALL_PROJECT_PACKAGES_FAIL = "GET_ALL_PROJECT_PACKAGES_FAIL"

// Update Project Package Installer
export const UPDATE_PROJECT_PACKAGE_INSTALLER = "UPDATE_PROJECT_PACKAGE_INSTALLER"
export const UPDATE_PROJECT_PACKAGE_INSTALLER_SUCCESS = "UPDATE_PROJECT_PACKAGE_INSTALLER_SUCCESS"
export const UPDATE_PROJECT_PACKAGE_INSTALLER_FAIL = "UPDATE_PROJECT_PACKAGE_INSTALLER_FAIL"

// Update Project Package Serial (for Installer)
export const UPDATE_PROJECT_PACKAGE_SERIAL = "UPDATE_PROJECT_PACKAGE_SERIAL"
export const UPDATE_PROJECT_PACKAGE_SERIAL_SUCCESS = "UPDATE_PROJECT_PACKAGE_SERIAL_SUCCESS"
export const UPDATE_PROJECT_PACKAGE_SERIAL_FAIL = "UPDATE_PROJECT_PACKAGE_SERIAL_FAIL"

// Reset Flags
export const RESET_PROJECT_PACKAGES_FLAG = "RESET_PROJECT_PACKAGES_FLAG"
